import { formatChipsShort } from '@polf/shared/locale'

import type { PolfLeaderboardPlayerEntryFragment } from '../../__generated__/hooks'
import Avatar from './Avatar'
import Rank from './Rank'

export type PolfMode = 'CHIPS' | 'STABLEFORD'

const PolfRow = ({
  entry,
  isYou,
  mode,
  onClick,
}: {
  entry: PolfLeaderboardPlayerEntryFragment
  isYou: boolean
  mode: PolfMode
  /** Tap-the-row to open the detail sheet. The whole row is the hit
   *  target so it's a button, not a li>onClick. */
  onClick?: () => void
}) => {
  const primary =
    mode === 'CHIPS'
      ? entry.chipsInclHoleCompetitions
      : entry.stablefordPoints.count
  const secondary =
    mode === 'CHIPS'
      ? `${entry.stablefordPoints.count} pts · ${entry.holesRegistred}/18`
      : `${formatChipsShort(entry.chipsInclHoleCompetitions)} chips · ${
          entry.holesRegistred
        }/18`
  return (
    <li className="border-b border-ink-100 last:border-b-0">
      <button
        type="button"
        onClick={onClick}
        className={`w-full flex items-center gap-3 py-3 px-4 text-left active:bg-ink-100 transition-colors ${
          isYou ? 'bg-green-50' : ''
        }`}
      >
        <Rank rank={entry.rank} />
        <Avatar name={entry.player.name} size={32} />
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-ink-900 truncate">
            {entry.player.name}
            {isYou ? (
              <span className="ml-2 text-xs font-bold text-green-700">
                · Du
              </span>
            ) : null}
          </div>
          <div className="text-[11px] text-ink-500 num truncate">
            {entry.player.hcp != null ? `hcp ${entry.player.hcp}` : ''}
            {entry.birdies.count > 0 ? ` · ${entry.birdies.count} 🐦` : ''}
            {entry.eagles.count > 0 ? ` · ${entry.eagles.count} 🦅` : ''}
            {entry.holeInOnes.count > 0
              ? ` · ${entry.holeInOnes.count} HiO`
              : ''}
          </div>
        </div>
        <div className="text-right shrink-0">
          <div className="font-mono num font-bold text-ink-900">
            {mode === 'CHIPS' ? formatChipsShort(primary) : primary}
          </div>
          <div className="text-[10px] text-ink-500 num truncate max-w-[100px]">
            {secondary}
          </div>
        </div>
      </button>
    </li>
  )
}

export default PolfRow
